import React, { useEffect, useState } from 'react';
import CameraMediaApi from "../../../api/camera-media-api";
import { Placeholder } from "react-bootstrap";
import classNames from "classnames";
import { CameraMedia } from "../../../helpers/interfaces";
import { formatDate_y_m_d_h_m } from "helpers/utils";

const cameraMediaApi = new CameraMediaApi();

type ImageProps = {
    className?: string;
    src: string;
    onClick?: (imageSrc: string) => void;
    media?: CameraMedia;
    onImageDownloaded?: (url: string, result: any) => void;
    [key: string]: any;
}
const GalleryImage = (props: ImageProps) => {



    const [imageSrc, setImageSrc] = useState<any>()
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        async function getImage() {
            try {
                if (!props.media) {
                    return;
                }
                setIsLoading(true);
                //let filename;
                let filename_for_download_url;
                let filename_for_thumbnail;
                let blob_for_video_thumbnail = null;
                let getHd;
                if (props.media.media_type == 'VIDEO'){
                    if (props.media.preview_file_path) {
                        // Use the zoom-cropped preview frame saved at video creation time.
                        const previewPathTokens = props.media.preview_file_path.replace(/\\/g, '/').split('/');
                        filename_for_thumbnail = previewPathTokens[previewPathTokens.length - 1];
                    } else {
                        // Older videos have no saved preview; fall back to the source image
                        // captured at the same time as the video's first frame.
                        let formatted_date_hour_and_min = formatDate_y_m_d_h_m(props.media.captured_at);
                        let resp = await cameraMediaApi.getSingleMediaItemByFieldCombo(
                            'IMAGE',
                            props.media.location_id,
                            formatted_date_hour_and_min,
                            props.media.sequence
                        )
                        filename_for_thumbnail = resp.filename;
                    }
                    filename_for_download_url = props.media.filename
                    getHd = false;
                } else {
                    filename_for_thumbnail = props.media.filename;
                    filename_for_download_url = filename_for_thumbnail;
                    getHd = props.media.hd_file_path !== null;
                }
                
                if (getHd) {
                    filename_for_thumbnail    = filename_for_thumbnail.replace('sd', 'hd');
                    filename_for_download_url = filename_for_download_url.replace('sd', 'hd');
                }


                const blob = await cameraMediaApi.getImage(props.media.camera_id, filename_for_download_url);
                if (props.media.media_type == 'VIDEO'){
                    blob_for_video_thumbnail = await cameraMediaApi.getImage(props.media.camera_id, filename_for_thumbnail);
                }
                try {
                    const downloadURL = URL.createObjectURL(blob);
                    // Create a new FileReader instance
                    const reader = new FileReader();
                    reader.addEventListener('load', () => {
                        setImageSrc(reader.result)
                        if (props.onImageDownloaded) {
                            props.onImageDownloaded(downloadURL, reader.result)
                        }
                    });
                    if (blob_for_video_thumbnail !== null) {
                        reader.readAsDataURL(blob_for_video_thumbnail)
                    } else {
                        reader.readAsDataURL(blob);
                    }
                } catch (err) {
                    console.log('error loading image', err);
                    setImageSrc(null)
                } finally {
                    setIsLoading(false);
                }
            } catch (e) {
                console.log(e)
            }
        }

        if (props.src) {
            setImageSrc(props.src)
        } else {
            getImage()
        }
    }, [props.src]);


    const onImageClicked = () => {
        if (props.onClick) {
            props.onClick(imageSrc);
        }
    }

    return (
        <React.Fragment>
            {isLoading ?
                <Placeholder as="p" animation="glow">
                    <Placeholder bg="dark" className={classNames(props.className, "img-fluid")}
                                 style={{minHeight: "180px"}} xs={12}/>
                </Placeholder>
                :
                <img
                    onClick={onImageClicked}
                    src={imageSrc} alt=""
                    className={classNames(props.className, "img-fluid")}/>
            }
        </React.Fragment>
    );
}

export default GalleryImage;
